import { Button, Card, Col, DatePicker, Pagination, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { AppStateContext, useAppContext } from "../../context/AppContext";
import useRequest from "../../hooks/useRequest";
import { Avatar, List, Skeleton } from "antd";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import Notification from "../../assets/images/notification-bell.svg";
import { Severty, ShowToast } from "../../helper/toast";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import confirm from "antd/lib/modal/confirm";
// import DeleteModal from "../../components/DeleteModal";
function NotificationList() {
  const { setPageHeading } = useContext(AppStateContext);
  const [loading, setLoading] = useState();
  const [list, setList] = useState([]);

  const [refresh, setRefresh] = useState(false);
  const [selected, setSelected] = useState("");

  const { language, setRefreshAppContext } = useAppContext();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const { request } = useRequest();

  const dates = {
    today: moment(new Date()).format("YYYY-MM-DD"),
    yesterday: moment(new Date().getTime() - 24 * 60 * 60 * 1000).format(
      "YYYY-MM-DD",
    ),
  };

  // const fetchData = (pagination) => {
  //   request({
  //     url: `${apiPath.listMyNotification}`,
  //     method: "GET",
  //     onSuccess: (data) => {
  //       setList(data.data.data);
  //       setPagination((prev) => ({
  //         ...prev,
  //         current: pagination?.page,
  //         total: data?.data.total,
  //         pageSize: data?.data.limit,
  //       }));
  //       setLoading(false);
  //     },
  //     onError: (err) => {
  //       console.log(err);
  //       setLoading(false);
  //     },
  //   });
  // };

  const fetchData = (
    page = pagination.current,
    pageSize = pagination.pageSize,
  ) => {
    setLoading(true);

    const params = new URLSearchParams();
    // 📄 Pagination
    params.append("page", page);
    params.append("limit", pageSize);
    request({
      url: `${apiPath.listMyNotification}?${params.toString()}`,
      method: "GET",

      onSuccess: (data) => {
        setList(data.data.data);

        setPagination({
          current: page,
          pageSize: pageSize,
          total: data.data.total,
        });

        setLoading(false);
      },

      onError: (err) => {
        console.log(err);
        setLoading(false);
      },
    });
  };

  const deleteNotifications = () => {
    setTimeout(() => {
      confirm({
        maskClosable: true,
        icon: <ExclamationCircleOutlined />,
        className: "tab_modal",
        cancelButtonProps: { color: "red" },
        content: (
          <p
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Are you sure you want to delete all notifications ?
          </p>
        ),
        onOk() {
          request({
            url: `${apiPath.deleteAllNotification}`,
            method: "DELETE",
            data: {},
            onSuccess: (data) => {
              fetchData(pagination);
              ShowToast(
                data.message || "Delete all notification Successfully",
                Severty.SUCCESS,
              );
            },
            onError: (error) => {
              setLoading(false);
              ShowToast(error, Severty.ERROR);
            },
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const readAllNotifcation = () => {
    request({
      url: `${apiPath.readAllNotification}`,
      method: "PUT",
      onSuccess: (data) => {
        ShowToast(
          data.message || "Notification  Read All Successfully",
          Severty.SUCCESS,
        );
        setRefresh((prev) => !prev);
        // setTimeout(() => {
        //   setRefreshAppContext(true);
        // }, 20);
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  const readSingleNotification = (id) => {
    request({
      url: `${apiPath.readNotification}/${id}`,
      method: "PUT",
      onSuccess: (data) => {
        ShowToast(
          data.message || "Notification Read Successfully",
          Severty.SUCCESS,
        );
        setRefresh((prev) => !prev);
        // setTimeout(() => {
        //   setRefreshAppContext(true);
        // }, 20);
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  const handlePaginationChange = (page = 1, pageSize = 10) => {
    fetchData(page, pageSize);
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [refresh]);

  useEffect(() => {
    setPageHeading("Notifications");
  }, []);

  return (
    <>
      <div className="tabled quoteManagement">
        <Card
          bordered={false}
          className="criclebox tablespace mb-24 main-new-notification-4545"
        >
          <div className="main-new-page-notification-pagehh45">
            {loading ? (
              <Skeleton />
            ) : list?.length > 0 ? (
              <>
                <div className="main-dltall-not-all">
                  <Button
                    disabled={!list?.length}
                    className="deleteall-main-button"
                    onClick={() => deleteNotifications()}
                  >
                    Delete All
                  </Button>

                  <Button
                    disabled={!list?.length}
                    className="deleteall-main-button"
                    onClick={readAllNotifcation}
                  >
                    Read All
                  </Button>
                </div>

                <List
                  itemLayout="horizontal"
                  dataSource={list}
                  renderItem={(item) => (
                    <List.Item
                      className={`list-notfy ${
                        item?.isRead
                          ? "Notification-read"
                          : "Notification-unread"
                      }`}
                    >
                      <List.Item.Meta
                        title={
                          <div
                            className="main-new-notification-main-heading"
                            onClick={() =>
                              item.isRead === false &&
                              readSingleNotification(item._id)
                            }
                          >
                            <div className="title-with-dot">
                              {!item?.isRead && <span className="unread-dot" />}
                              <span className="tital-notfy">{item?.title}</span>
                            </div>

                            <span className="dics-notfy">
                              {moment(item?.createdAt).format(
                                "YYYY-MM-DD hh:mm A",
                              )}
                            </span>
                          </div>
                        }
                        avatar={
                          <Avatar
                            className="noti-avtar noti-avtar-new-ooo"
                            src={
                              item?.data?.user?.image
                                ? item?.data?.user?.image
                                : Notification
                            }
                          />
                        }
                        description={item?.message}
                      />
                    </List.Item>
                  )}
                />

                {/* ✅ Pagination — Same Theme */}
                <div className="customPagination customPaginationmain-newwwww">
                  <Pagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    showSizeChanger
                    showQuickJumper
                    pageSizeOptions={["10", "20", "30", "50"]}
                    onChange={handlePaginationChange}
                  />
                </div>
              </>
            ) : (
              <h3>No Notification Found</h3>
            )}
          </div>
        </Card>
      </div>
    </>
  );
}

export default NotificationList;
